
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer/forgotpassword.html",
      function () {
        return require("private-next-pages/customer/forgotpassword.html.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer/forgotpassword.html"])
      });
    }
  